import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";
import FinancialRiskCard from "components/FinancialRisk/FinancialRiskCard";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";
import { isNullOrEmptyString } from "shared/utils";
import { getCountryFormDefinition } from "shared/utils/cmsUtils";

export const financialDetailsSection = (
  existingCompany: CompanyFormState,
  sourceCompany: CompanyFormState,
  currentCompany: CompanyFormState,
  setCurrentCompany: (company: CompanyFormState) => void
): MergeFormSection => {
  const formDefinition = getCountryFormDefinition(currentCompany.address.postalAddress.country.key, serverReference);

  return {
    key: "financialDetails",
    title: RESX.Financial.FinancialDetails,
    fields: [{
      key: "financialRisk",
      label: RESX.Promoter.FinancialRisk,
      currentValue: currentCompany.financialRisk,
      existingValue: existingCompany.financialRisk,
      sourceValue: sourceCompany.financialRisk,
      isEmpty: (v: server.dto.FinancialRisk) => v.level === "unknown",
      render: (v: server.dto.FinancialRisk) => <FinancialRiskCard financialRisk={v} />,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        financialRisk: sourceCompany.financialRisk,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        financialRisk: existingCompany.financialRisk,
      }),
    }, {
      key: "euVatNumber",
      label: formDefinition.euVatNumber.label,
      sublabel: formDefinition.euVatNumber.sublabel,
      hidden: !formDefinition.euVatNumber.displayInUI,
      currentValue: currentCompany.euVatNumber,
      existingValue: existingCompany.euVatNumber,
      sourceValue: sourceCompany.euVatNumber,
      isEmpty: (v) => !v.number,
      render: (value: server.dto.EuVatNumber) => <span>{value.number}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        euVatNumber: sourceCompany.euVatNumber,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        euVatNumber: existingCompany.euVatNumber,
      }),
    }, {
      key: "fiscalNumber1",
      label: formDefinition.fiscalNumber1.label,
      sublabel: formDefinition.fiscalNumber1.sublabel,
      hidden: !formDefinition.fiscalNumber1.displayInUI,
      currentValue: currentCompany.fiscalNumber1,
      existingValue: existingCompany.fiscalNumber1,
      sourceValue: sourceCompany.fiscalNumber1,
      isEmpty: (value: string) => isNullOrEmptyString(value),
      render: (value: string) => <span>{value}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        fiscalNumber1: sourceCompany.fiscalNumber1,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        fiscalNumber1: existingCompany.fiscalNumber1,
      }),
    }, {
      key: "fiscalNumber2",
      label: formDefinition.fiscalNumber2.label,
      sublabel: formDefinition.fiscalNumber2.sublabel,
      hidden: !formDefinition.fiscalNumber2.displayInUI,
      currentValue: currentCompany.fiscalNumber2,
      existingValue: existingCompany.fiscalNumber2,
      sourceValue: sourceCompany.fiscalNumber2,
      isEmpty: (value: string) => isNullOrEmptyString(value),
      render: (value: string) => <span>{value}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        fiscalNumber2: sourceCompany.fiscalNumber2,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        fiscalNumber2: existingCompany.fiscalNumber2,
      }),
    }, {
      key: "legalStructure",
      label: formDefinition.legalStructure.label,
      sublabel: formDefinition.legalStructure.sublabel,
      hidden: !formDefinition.legalStructure.displayInUI,
      currentValue: currentCompany.legalStructure,
      existingValue: existingCompany.legalStructure,
      sourceValue: sourceCompany.legalStructure,
      isEmpty: (value: string) => isNullOrEmptyString(value),
      render: (value: string) => <span>{value}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        legalStructure: sourceCompany.legalStructure,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        legalStructure: existingCompany.legalStructure,
      }),
    }, {
      key: "businessRegistrationNumber",
      label: formDefinition.businessRegistrationNumber.label,
      sublabel: formDefinition.businessRegistrationNumber.sublabel,
      hidden: !formDefinition.businessRegistrationNumber.displayInUI,
      currentValue: currentCompany.businessRegistrationNumber,
      existingValue: existingCompany.businessRegistrationNumber,
      sourceValue: sourceCompany.businessRegistrationNumber,
      isEmpty: (value: string) => isNullOrEmptyString(value),
      render: (value: string) => <span>{value}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        businessRegistrationNumber: sourceCompany.businessRegistrationNumber,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        businessRegistrationNumber: existingCompany.businessRegistrationNumber,
      }),
    }, {
      key: "internalId",
      label: RESX.Company.CustomerNumber,
      currentValue: currentCompany.internalId,
      existingValue: existingCompany.internalId,
      sourceValue: sourceCompany.internalId,
      isEmpty: (value: string) => isNullOrEmptyString(value),
      render: (value: string) => <span>{value}</span>,
      onSourceClick: () => setCurrentCompany({
        ...currentCompany,
        internalId: sourceCompany.internalId,
      }),
      onExistingClick: () => setCurrentCompany({
        ...currentCompany,
        internalId: existingCompany.internalId,
      }),
    }],
  }
}